import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteQuestion } from "../../services/question";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useDeleteQuestion = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteQuestion,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["questionnaire_content"] });
                toast.success("Question deleted successfully");
                indicator.setIsProcessRunning(false);
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useDeleteQuestion;